import { useDispatch, useSelector, shallowEqual } from 'react-redux';
import { useEffect, useRef, useState } from 'react';
import { isValidUserId } from '../../../../../constants/Validators';
import { fetchUserStatusAction } from '../../../store/actions/UserActions';
import { isEmpty } from 'lodash';
import { trackVerifyUsernameEvent, trackVerifyUsernameLoad } from '../../../../../utils/railsAnalytics';

type VerifuUserNameState = {
  disabled: boolean,
  rotate: boolean,
  validationFail: boolean,
};

const initialStates = {
  disabled: true,
  rotate: false,
  validationFail: false,
};

export const useVerifyUserNameContainer = (props) => {
  const dispatch = useDispatch();
  const { user: { userStatus } } = useSelector((state: any) => state );
  const [ state, setState ] = useState<VerifuUserNameState>(initialStates);
  const [ showModal, setShowModal ] = useState(props.showModal || false);
  const [ error, setError ] = useState( false);
  const [ irctcUserId, setIrctcUserId ] = useState(props.userStatus.userId);

  const timer = useRef(null);

  useEffect(() => {
    trackVerifyUsernameLoad();
    if (props.userStatus) {
      setIrctcUserId(props.userStatus.userId);
    }
    //clear timer on unMount
    return () => {
      clearTimeout(timer.current);
    };
  }, []);

  useEffect(() => {
    if (userStatus.error) {
      setError(userStatus.error);
    } else if ( userStatus.userId && userStatus.nextPage && state.rotate) {
      goToVerifiedPage(userStatus);
    }
  }, [ props.userStatus ]);

  const goToVerifiedPage = (userStatus) => {
    // redirects to next user flow page according to the status received
    // nextPage property is set in Node backend.
    if (userStatus.nextPage === 'usernameVerified') {
      props.updateVerifiedUser(irctcUserId);
    } else if (!isEmpty(userStatus)) {
      props.switchModal(userStatus.nextPage, userStatus);
    }
  };

  const handleInputKeyUpViaParent = (val) => {
    setIrctcUserId(val);
    if (val && val.length > 0 && isValidUserId(val)) {
      setState({
        ...state,
        validationFail: false,
      });
    } else {
      setState({
        ...state,
        validationFail: true,
      });
    }

    if (val.length > 0) {
      if (isValidUserId(val)) {
        setState({
          ...state,
          validationFail: false,
        });
      } else {
        setState({
          ...state,
          validationFail: true,
        });
      }
    }

    if (val.length >= 3 && isValidUserId(val)) {
      setState({
        ...state,
        disabled: false,
      });
    } else {
      setState({
        ...state,
        disabled: true,
      });
    }
  };

  const goToIRCTCRegistrationPage = () => {
    trackVerifyUsernameEvent('create_irctc_account_clicked');
    props.createAccount();
  };

  const goToForgotUsernamePage = () => {
    trackVerifyUsernameEvent('irctc_forgot_username_clicked');
    props.switchModal('forgotUsername', userStatus);
  };

  const closeModal = () => {
    setError(false);
    setShowModal(false);
    props.closeModal();
  };

  const rotateLoader = () => {
    if (!state.disabled) {
      setState({
        ...state,
        rotate: true,
      });
      trackVerifyUsernameEvent('irctc_username_verify_clicked');
      dispatch(fetchUserStatusAction(irctcUserId));

      timer.current = setTimeout(() => {
        setState({
          ...state,
          rotate: false,
        });
      }, 1500);
    }
  };

  return {
    props: {
      userStatus: (userStatus || props.userStatus),
      showModal,
      state,
      error,
      irctcUserId,
    },

    action: {
      rotateLoader,
      closeModal,
      goToIRCTCRegistrationPage,
      goToForgotUsernamePage,
      handleInputKeyUpViaParent,
    },
  };
};
